import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=cd0ace2c&scoped=true&"
var script = {}
import style0 from "./PrimaryButton.vue?vue&type=style&index=0&id=cd0ace2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0ace2c",
  null
  
)

export default component.exports